<template>
    <div class="relative z-2 pt-20 pb-24">
        <a id="main-content" class="fixed top-0" tabindex="-1"></a>

        <div class="container">
            <div class="flex flex-wrap items-center mt-4 lg:mt-6">
                <div class="flex items-center breadcrumb-item"></div>
                <NuxtLink :to="localePath('index')" class="mr-1" :aria-label="$t('navigation.homepage')">
                    <i class="pi pi-home"></i>
                </NuxtLink>
                <i class="pi pi-chevron-right mx-3 text-sm"></i>
                <span class="font-Poppins mr-1 text-sm uppercase pointer-events-none">
                    {{ $t('visitor_information.title') }}
                </span>
                <i class="pi pi-chevron-right mx-3 text-sm"></i>
                <span class="font-Poppins mr-1 text-sm uppercase pointer-events-none">
                    {{ $t('visitor_information.welcome') }}
                </span>
            </div>
        </div>

        <div class="container grid grid-cols-12 base-responsive-gap mt-6">
            <div class="col-span-12 lg:col-span-7">
                <h1 class="header-1 mb-4"><T t="visitor_information_welcome.title" /></h1>
                <p class="lead"><T t="visitor_information_welcome.description" /></p>
            </div>
        </div>

        <div
            id="liget-manual-wrap"
            ref="contentWrapper"
            class="container relative flex lg:block mt-12 lg:mt-40 lg:pb-96"
        >
            <div class="mobile-manual-progress relative z-2 w-10 lg:hidden" style="margin: 14px 4px 74px 0">
                <div class="w-5 h-5 rounded-full bg-yellow-500 sticky top-[15rem]"></div>
            </div>

            <div id="liget-manual" ref="svgPathContainer" class="w-[998px] mx-auto z-0 hidden lg:block">
                <svg
                    width="998"
                    height="4096"
                    viewBox="-10 -10 978 4126"
                    class="w-full"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        ref="motionPath"
                        d="M646 2C782 2 866 117 866 275C866 433 744 607 511.001 558.5C333.741 521.602 232 525 123 613C-1.8914 713.83 7.1861 921.39 130 1041C245 1153 364 1146.7 577 1100C790 1053.3 948 1184 960 1370C970.316 1529.9 903 1794 486.5 1778C70 1762 10 1975 22.5 2178.5C35 2382 172 2537.06 487.5 2535C615 2534.17 801 2570 801 2731C801 2892 697 2949 487.5 2949C278 2949 2.5 2948.5 2.5 3227.5C2.5 3506.5 267 3492 487.5 3492C708 3492 964.5 3444.5 964.5 3684.5C964.5 3924.5 675.5 3835 675.5 4088"
                        stroke="#F9DD39"
                        stroke-width="4"
                        stroke-linecap="round"
                    />
                    <circle cx="646" cy="2" r="9.5" fill="white" stroke="#F9DD39" stroke-width="4" />
                    <circle cx="46.5" cy="724.5" r="9.5" fill="white" stroke="#F9DD39" stroke-width="4" />
                    <circle cx="959.5" cy="1368.5" r="9.5" fill="white" stroke="#F9DD39" stroke-width="4" />
                    <circle cx="86.5" cy="1906.5" r="9.5" fill="white" stroke="#F9DD39" stroke-width="4" />
                    <circle cx="800.5" cy="2744.5" r="9.5" fill="white" stroke="#F9DD39" stroke-width="4" />
                    <circle cx="26.5" cy="3102.5" r="9.5" fill="white" stroke="#F9DD39" stroke-width="4" />
                    <circle cx="961.5" cy="3642.5" r="9.5" fill="white" stroke="#F9DD39" stroke-width="4" />
                    <circle cx="676" cy="4088" r="9.5" fill="white" stroke="#F9DD39" stroke-width="4" />

                    <circle id="dot" cx="0" cy="0" r="9.5" fill="#F9DD39" stroke="#F9DD39" stroke-width="4" />
                </svg>
            </div>

            <div>
                <div
                    v-if="false"
                    class="bg-illustration -top-24 -left-24 w-[40rem] h-[40rem] z-0 hidden lg:block"
                    v-lazy-background :lazy-background="require('~/assets/images/shapes/shape-8_yellow-400.png')"
                ></div>

                {{/* * */}}
                {{/* Bicycle (left) */}}
                <div class="manual-content pb-64 lg:pb-[30rem] 2xl:pb-[32rem] lg:top-0">
                    <div class="col-span-12 lg:col-span-5 lg:col-start-2">
                        <h2 class="header-3 mb-2"><T t="visitor_information_welcome.bicycle.title" /></h2>
                        <div><T t="visitor_information_welcome.bicycle.description" /></div>
                        <Button
                            v-if="!/btn_url/.test($t('visitor_information_welcome.bicycle.btn_url'))"
                            :to="$t('visitor_information_welcome.bicycle.btn_url')"
                            :label="$t('visitor_information_welcome.bicycle.btn_label')"
                            target="_blank"
                            class="mt-4"
                        />
                    </div>

                    <div
                        class="bg-illustration hidden lg:block w-40 h-52 -top-32 right-12"
                        v-lazy-background :lazy-background="require('assets/images/illustrations/balloon.svg')"
                    ></div>

                    <div
                        class="bg-illustration w-48 h-36 lg:w-52 lg:h-40 bottom-20 lg:bottom-64 left-4 lg:left-unset lg:right-72 2xl:right-[30rem]"
                        v-lazy-background :lazy-background="require('assets/images/illustrations/bicycle.svg')"
                    ></div>

                    <div
                        class="bg-illustration hidden lg:block w-96 h-96 bottom-12 left-0"
                        v-lazy-background :lazy-background="require('assets/images/illustrations/tree-group.svg')"
                    ></div>
                </div>

                {{/* * */}}
                {{/* Dog walking (right) */}}
                <div class="manual-content pb-64 lg:pb-[10rem] 2xl:pb-[10rem] lg:top-[40rem]">
                    <div
                        class="relative col-span-12 lg:col-span-8 lg:col-start-5 xl:col-span-7 xl:col-start-6 2xl:col-span-6 2xl:col-start-6"
                    >
                        <h2 class="header-3 mb-2"><T t="visitor_information_welcome.dog_walking.title" /></h2>
                        <div><T t="visitor_information_welcome.dog_walking.description" /></div>
                        <Button
                            v-if="!/btn_url/.test($t('visitor_information_welcome.dog_walking.btn_url'))"
                            :to="$t('visitor_information_welcome.dog_walking.btn_url')"
                            :label="$t('visitor_information_welcome.dog_walking.btn_label')"
                            target="_blank"
                            class="mt-4"
                        />
                    </div>

                    <div
                        class="bg-illustration w-36 h-36 lg:h-56 bottom-24 lg:top-8 right-12 lg:right-0 lg:-translate-y-full"
                        v-lazy-background :lazy-background="require('assets/images/illustrations/man-walking-dog.svg')"
                    ></div>
                </div>

                {{/* * */}}
                {{/* Children (left) */}}
                <div class="manual-content lg:pb-[6rem] lg:top-[76rem]">
                    <div
                        class="col-span-12 lg:col-span-8 lg:col-start-1 xl:col-span-7 xl:col-start-2 2xl:col-span-6 2xl:col-start-2 relative"
                    >
                        <div
                            class="bg-illustration hidden lg:block w-28 h-28 top-12 -right-40"
                            v-lazy-background :lazy-background="require('assets/images/illustrations/ice-cream-girl.svg')"
                        ></div>

                        <div class="flex flex-col-reverse lg:flex-col w-full pb-52 lg:pb-0">
                            <div
                                class="bg-illustration w-28 h-28 lg:w-16 lg:h-28 bottom-20 lg:-top-4 right-12 lg:right-[unset] lg:left-8 lg:-translate-y-full"
                                v-lazy-background :lazy-background="require('assets/images/illustrations/kid-throwing-football.svg')"
                            ></div>

                            <div>
                                <h2 class="header-3 mb-2"><T t="visitor_information_welcome.children.title" /></h2>
                                <div><T t="visitor_information_welcome.children.description" /></div>

                                <Button
                                    v-if="!/btn_url/.test($t('visitor_information_welcome.children.btn_url'))"
                                    :to="$t('visitor_information_welcome.children.btn_url')"
                                    :label="$t('visitor_information_welcome.children.btn_label')"
                                    target="_blank"
                                    class="mt-4"
                                />
                            </div>
                        </div>
                    </div>

                    <div
                        class="bg-illustration hidden lg:block w-72 h-72 bottom-12 right-0 xl:right-12 2xl:right-44"
                        v-lazy-background :lazy-background="require('assets/images/illustrations/flower-group-1.svg')"
                    ></div>
                </div>

                {{/* * */}}
                {{/* Sport (right) */}}
                <div class="manual-content lg:pb-[14rem] lg:top-[118rem]">
                    <div
                        class="col-span-12 lg:col-span-8 lg:col-start-5 2xl:col-span-6 2xl:col-start-6 3xl:col-span-7 3xl:col-start-6 relative pb-52 lg:pb-0"
                    >
                        <div
                            class="bg-illustration hidden lg:block w-28 h-44 -left-32 top-4"
                            v-lazy-background :lazy-background="require('assets/images/illustrations/standing-football-guy.svg')"
                        ></div>
                        <div
                            class="bg-illustration hidden lg:block w-36 h-36 -left-52 bottom-16"
                            v-lazy-background :lazy-background="require('assets/images/illustrations/yoga-guy.svg')"
                        ></div>
                        <div
                            class="bg-illustration w-48 h-32 bottom-20 lg:bottom-0 right-4 lg:right-0 lg:translate-y-full"
                            v-lazy-background :lazy-background="require('assets/images/illustrations/man-in-boat.svg')"
                        ></div>

                        <h2 class="header-3 mb-2"><T t="visitor_information_welcome.sport.title" /></h2>
                        <div><T t="visitor_information_welcome.sport.description" /></div>

                        <Button
                            v-if="!/btn_url/.test($t('visitor_information_welcome.sport.btn_url'))"
                            :to="$t('visitor_information_welcome.sport.btn_url')"
                            :label="$t('visitor_information_welcome.sport.btn_label')"
                            target="_blank"
                            class="mt-4"
                        />
                    </div>
                </div>

                {{/* * */}}
                {{/* Events (left) */}}
                <div class="manual-content lg:pb-[10rem] xl:pb-[12rem] lg:top-[166rem]">
                    <div class="col-span-12 lg:col-span-5 lg:col-start-2 relative pb-52 lg:pb-0">
                        <div class="flex flex-col-reverse lg:flex-col w-full">
                            <div
                                class="bg-illustration w-44 h-32 lg:w-48 lg:h-32 bottom-16 lg:bottom-unset lg:-top-32 left-0"
                                v-lazy-background :lazy-background="require('assets/images/illustrations/picnic-woman.svg')"
                                style="transform: rotateY(180deg)"
                            ></div>

                            <div>
                                <h2 class="header-3 mb-2"><T t="visitor_information_welcome.events.title" /></h2>
                                <div><T t="visitor_information_welcome.events.description" /></div>

                                <Button
                                    v-if="!/btn_url/.test($t('visitor_information_welcome.events.btn_url'))"
                                    :to="$t('visitor_information_welcome.events.btn_url')"
                                    :label="$t('visitor_information_welcome.events.btn_label')"
                                    target="_blank"
                                    class="mt-4"
                                />
                            </div>
                        </div>

                        <div
                            class="bg-illustration hidden lg:block w-20 h-28 bottom-4 -right-36"
                            v-lazy-background :lazy-background="require('assets/images/illustrations/tree2.svg')"
                        ></div>
                    </div>

                    <div
                        class="bg-illustration hidden lg:block w-40 h-28 bottom-4 right-20"
                        v-lazy-background :lazy-background="require('assets/images/illustrations/flower-group-2.svg')"
                    ></div>
                </div>

                {{/* * */}}
                {{/* Protect the environment (right) */}}
                <div class="manual-content lg:pb-[12rem] xl:pb-[10rem] 2xl:pb-[18rem] 3xl:pb-[15rem] lg:top-[190rem]">
                    <div
                        class="bg-illustration hidden lg:block w-20 h-28 -top-32 left-0"
                        v-lazy-background :lazy-background="require('assets/images/illustrations/tree1.svg')"
                    ></div>

                    <div
                        class="bg-illustration hidden lg:block w-24 h-20 bottom-24 xl:bottom-32 right-0"
                        v-lazy-background :lazy-background="require('assets/images/illustrations/birds.svg')"
                    ></div>

                    <div
                        class="col-span-12 lg:col-span-7 lg:col-start-6 xl:col-span-5 xl:col-start-6 relative pb-52 lg:pb-0"
                    >
                        <div
                            class="bg-illustration hidden lg:block w-20 h-24 top-4 -left-40"
                            v-lazy-background :lazy-background="require('assets/images/illustrations/roses.svg')"
                        ></div>

                        <div class="flex flex-col-reverse lg:flex-col w-full">
                            <div
                                class="bg-illustration w-44 h-32 lg:w-48 lg:h-36 bottom-16 lg:-bottom-12 left-4 lg:-left-64"
                                v-lazy-background :lazy-background="require('assets/images/illustrations/relaxing-guy.svg')"
                            ></div>

                            <div>
                                <h2 class="header-3 mb-2">
                                    <T t="visitor_information_welcome.protect_the_environment.title" />
                                </h2>
                                <div><T t="visitor_information_welcome.protect_the_environment.description" /></div>

                                <Button
                                    v-if="
                                        !/btn_url/.test(
                                            $t('visitor_information_welcome.protect_the_environment.btn_url')
                                        )
                                    "
                                    :to="$t('visitor_information_welcome.protect_the_environment.btn_url')"
                                    :label="$t('visitor_information_welcome.protect_the_environment.btn_label')"
                                    target="_blank"
                                    class="mt-4"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {{/* * */}}
                {{/* Facilities (left) */}}
                <div class="manual-content pb-56 lg:pb-[18rem] 2xl:pb-[15rem] lg:top-[220rem]">
                    <div
                        class="bg-illustration w-32 h-36 lg:w-36 lg:h-40 bottom-16 right-12 lg:right-0"
                        v-lazy-background :lazy-background="require('assets/images/illustrations/man-in-chair.svg')"
                    ></div>

                    <div
                        class="bg-illustration hidden lg:block w-80 h-80 bottom-12 2xl:bottom-0 left-40 2xl:left-52"
                        v-lazy-background :lazy-background="require('assets/images/illustrations/dog-with-trees-group.svg')"
                    ></div>

                    <div class="col-span-12 lg:col-span-8 2xl:col-span-6 2xl:col-start-2 relative">
                        <div
                            class="bg-illustration hidden lg:block w-24 h-40 top-8 -right-48"
                            v-lazy-background :lazy-background="require('assets/images/illustrations/coffee-girl.svg')"
                        ></div>

                        <h2 class="header-3 mb-2"><T t="visitor_information_welcome.facilities.title" /></h2>
                        <div><T t="visitor_information_welcome.facilities.description" /></div>

                        <Button
                            v-if="!/btn_url/.test($t('visitor_information_welcome.facilities.btn_url'))"
                            :to="$t('visitor_information_welcome.facilities.btn_url')"
                            :label="$t('visitor_information_welcome.facilities.btn_label')"
                            target="_blank"
                            class="mt-4"
                        />
                    </div>
                </div>

                {{/* * */}}
                {{/* Newsletter (right) */}}
                <div class="manual-content lg:top-[257rem]">
                    <div class="col-span-12 lg:col-span-4 lg:col-start-8 2xl:col-start-7 pb-52 lg:pb-0 relative">
                        <div class="mb-4"><T t="visitor_information_welcome.newsletter.description" /></div>

                        <Button
                            v-if="!/btn_url/.test($t('visitor_information_welcome.newsletter.btn_url'))"
                            :to="$t('visitor_information_welcome.newsletter.btn_url')"
                            :label="$t('visitor_information_welcome.newsletter.btn_label')"
                            target="_blank"
                            class="mt-4"
                        />

                        <div
                            class="bg-illustration w-48 h-32 bottom-16 lg:-bottom-4 left-4 lg:-left-56"
                            v-lazy-background :lazy-background="require('assets/images/illustrations/lying-girl.svg')"
                        ></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="absolute bottom-0 left-0 w-full bg-gradient-to-t from-gray-100" style="height: 50vh"></div>
    </div>
</template>

<script>
export default {
    name: 'VisitorInformationIndex',
    head() {
        return {
            title: this.$getPageTitle('visitor-information.index'),
            meta: this.$getPageMetaData('visitor-information.index'),
        };
    },
    mounted() {
        // Update dot position when we get a scroll event.
        window.addEventListener('scroll', this.updateDotPosition);

        // Set the initial position of the dot.
        this.updateDotPosition();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.updateDotPosition);
    },
    methods: {
        updateDotPosition() {
            if (window.innerWidth < 1024) {
                return;
            }

            const contentWrapperTop = this.$refs.contentWrapper.offsetTop;
            const svgPathContainerHeight = this.$refs.svgPathContainer.offsetHeight;

            let scrollPercentage = 0;

            // What percentage down the page are we?
            if (window.scrollY > contentWrapperTop - document.documentElement.clientHeight) {
                if (window.scrollY === 0) {
                    // console.log('nothing');
                } else {
                    scrollPercentage =
                        (window.scrollY - contentWrapperTop + document.documentElement.clientHeight / 2) /
                        svgPathContainerHeight;
                }
            } else {
                scrollPercentage = 0;
            }

            // Get path length
            const path = this.$refs.motionPath;
            const pathLen = path.getTotalLength();

            // Get the position of a point at <scrollPercentage> along the path.
            const pt = path.getPointAtLength(scrollPercentage * pathLen);

            // Position the red dot at this point
            const dot = document.getElementById('dot');
            dot.setAttribute('transform', 'translate(' + pt.x + ',' + pt.y + ')');
        },
    },
};
</script>

<style scoped>
.manual-content-wrapper {
    @apply lg:absolute;
}
.manual-content {
    z-index: 1;
    @apply relative grid grid-cols-12 gap-x-7 pl-4 lg:pl-0 lg:absolute lg:left-0;

    @media (max-width: 1024px) {
        &::after {
            content: '';
            display: block;
            position: absolute;
            left: -24px;
            top: 14px;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: #fff;
            border: 4px solid rgb(249, 221, 57);
            z-index: 1;
        }

        &::before {
            content: '';
            width: 4px;
            background: rgb(249, 221, 57);
            top: 0;
            bottom: 0;
            position: absolute;
            left: -16px;
            z-index: 0;
        }

        &:first-child {
            &::before {
                top: 16px;
                border-radius: 2px 2px 0 0;
            }
        }

        &:last-child {
            &::after {
                top: auto;
                bottom: 74px;
            }
            &::before {
                bottom: 84px;
                border-radius: 0 0 2px 2px;
            }
        }
    }
}
</style>
